<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :show-title="true"
    :width="'80%'"
    :height="700"
    :title="getTitle.primary"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-work-order-release-info',
    }"
    ref="gc-popup"
  >
    <DxToolbarItem
      v-if="getTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${getTitle.secondary}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form">
      <gc-form
        :key="1"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="getFormModel"
        :form-mode="'review'"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 85"
      />

      <div class="data-grid">
        <dx-data-grid
          v-if="getVisible"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getColumns"
          :data-source="getDataSourceConfig"
          :row-alternation-enabled="true"
          :height="getGridHeight"
          :width="'100%'"
          :ref="'release-info-list-grid'"
          @content-ready="onContentReady"
        >
          <DxScrolling
            :mode="'virtual'"
            :row-rendering-mode="'virtual'"
            :preload-enabled="true"
          />
          <DxSearchPanel :visible="false" />

          <template #release-template="{ data }">
            <div>
              <a @click="onProdQtyClicked(data)">{{ data.text }}</a>
            </div>
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>

        <GcFooter v-if="showFooter">
          <template #rightContent>
            <div
              class="gc-grid-footer-item"
              v-for="item in footerRightItems"
              :key="item.label"
            >
              <label class="gc-footer-label">{{ item.label }}</label>
              <GcFooterItem
                :value="item.value"
                :format="item.format"
                :length="item.format == 'Decimal-16-4C' ? 8 : 6"
              />
            </div>
          </template>
        </GcFooter>
      </div>

      <gc-popup-release-model
        :popupConfig="releasePopupInfo"
        :onHide="onReleaseLevelPopupHide"
        v-if="releasePopupInfo.isPopupShow"
        :showLoading="showLoading"
        :popup-mode="'review'"
      />
    </div>
  </DxPopup>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { ProductionReleaseService } from "../../_services/api/production/production-release.service";
import { WorkOrderService } from "../../_services/api/production/work-order.service";
import { FeatureStorage } from "../../_services/storage";
import GcPopupReleaseModel from "./gc-popup-release-model.vue";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { getSortSettingsFromCombinedSetting } from "../../_helpers/views/work-order";

export default {
  components: {
    GcPopupReleaseModel,
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      model: {},
      reversalInitiated: false,
      releasePopupInfo: {
        isPopupShow: false,
        dataModel: {},
      },
      WorkOrderInstance: "Core",
      showFooter: false,
    };
  },
  async created() {
    await this.loadWorkOrderInstance();

    const ProductionReleaseDetailBreakdownDefaultSortColumns =
      await getSortSettingsFromCombinedSetting(
        "ProductionReleaseDetailBreakdownDefaultSortColumns",
        this.getColumns.map((col) => col.dataField)
      );

    if (ProductionReleaseDetailBreakdownDefaultSortColumns.length > 0) {
      ProductionReleaseDetailBreakdownDefaultSortColumns.forEach((element) => {
        const targetCol = this.getColumns.find(
          (col) => col.dataField === element.dataField
        );

        if (targetCol) {
          targetCol.sortOrder = element.sortOrder;
          targetCol.sortIndex = element.sortIndex;
        }
      });

      this.$nextTick(() => {
        const dataGrid = this.$refs["release-info-list-grid"].instance;
        if (dataGrid) {
          dataGrid.option("columns", this.getColumns);
          dataGrid.refresh(true);
        }
      });
    }
  },
  methods: {
    async loadWorkOrderInstance() {
      let workOrderInstanceSetting =
        await SettingsService.getBySettingNameFromDb("WorkOrderInstance");

      if (workOrderInstanceSetting.data.value.length > 0) {
        this.WorkOrderInstance =
          workOrderInstanceSetting.data.value[0].SettingValue;
      }
    },
    onReleaseLevelPopupHide() {
      this.releasePopupInfo.isPopupShow = false;
    },
    onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);

      if (this.reversalInitiated) {
        this.$emit("onRefreshDataList");
      }
    },
    async reverseProductionRelease(e) {
      this.showLoading(true);
      let lineData = e.row.data;

      try {
        const response =
          await ProductionReleaseService.reverseProductionRelease({
            ProductionReleaseCode: lineData.ProductionReleaseCode,
            ProductionReleaseLineNo: lineData.LineNo,
          });

        const dataGrid = this.$refs["release-info-list-grid"];
        if (response && dataGrid && dataGrid.instance) {
          this.reversalInitiated = true;
          dataGrid.instance.refresh();
        }

        this.$nextTick(() => {
          this.$notify(
            `The ${lineData.ProductionReleaseCode} release for ${
              lineData.ProductCode
            } product has been successfully reversed by ${formatNumber(
              lineData.ProductionUMQty,
              "##,###,###,###,##0.0000"
            )}`,
            "success"
          );
          this.getReleaseFooterTotals();
        });
      } catch (error) {
        this.displayServerError(error, "Error reversing production release");
      } finally {
        this.showLoading(false);
        // this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
        // this.$emit("refreshData");
      }
    },
    async onProdQtyClicked(e) {
      this.showLoading(true);
      try {
        const response =
          await ProductionReleaseService.getProductionReleaseHeader(
            e.data.ProductionReleaseCode
          );
        if (response && response.data && response.data.value.length > 0) {
          this.releasePopupInfo.dataModel = {
            BranchCode: response.data.value[0].BranchCode,
            WorkOrderCode: e.data.WorkOrderCode,
            ReleaseDate: response.data.value[0].DateIn.replace("Z", ""),
            ProductCode: e.data.ProductCode,
            BatchNo: e.data.BatchNo,
            ProductDescription: e.data.ReleasedProductDescription1,
            ProductionReleaseCode: e.data.ProductionReleaseCode,
          };
          this.releasePopupInfo.isPopupShow = true;
        } else {
          this.displayServerError(null, "No data found in the response");
        }
      } catch (error) {
        this.displayServerError(
          error,
          "Error fetching production release details"
        );
        return;
      } finally {
        this.showLoading(false);
      }
    },
    onContentReady() {
      this.$nextTick(() => {
        this.showFooter = true;
      });
    },
    async getReleaseFooterTotals() {
      var date = new Date(
        this.popupConfig.dataModel.ReleaseDate
      ).toFilterDateString();
      try {
        const response = await ProductionReleaseService.getReleaseFooterTotals(
          `WorkOrderCode eq ${parseInt(
            this.popupConfig.dataModel.WorkOrderCode
          )} and ProductCode eq '${
            this.popupConfig.dataModel.ProductCode
          }' and BatchNo eq '${
            this.popupConfig.dataModel.BatchNo
          }' and ReleaseDate eq ${date}`,
          this.WorkOrderInstance
        );

        if (
          response &&
          response.data &&
          response.data.value &&
          response.data.value.length > 0
        ) {
          // Process the response data
          const footerTotals = response.data.value[0];
          this.popupConfig.dataModel = {
            ...this.popupConfig.dataModel,
            ...{
              CardCount: footerTotals.CardCount,
              PalletCount: footerTotals.PalletCount,
              BatchCount: footerTotals.BatchCount,
              StockUMQty: footerTotals.StockUMQty,
            },
          };
        }
      } catch (error) {
        this.displayServerError(error, "Error fetching release footer totals");
      }
    },
  },
  computed: {
    getGridHeight() {
      return 530;
    },
    getDataSourceConfig() {
      var date = new Date(
        this.popupConfig.dataModel.ReleaseDate
      ).toFilterDateString();

      return WorkOrderService.dataSourceConfig(
        this.WorkOrderInstance === "Core"
          ? "api/ProductionReleaseDetailList"
          : "api/AlmondcoProductionReleaseDetail",
        {
          filter: `WorkOrderCode eq ${parseInt(
            this.popupConfig.dataModel.WorkOrderCode
          )} and ProductCode eq '${
            this.popupConfig.dataModel.ProductCode
          }' and BatchNo eq '${
            this.popupConfig.dataModel.BatchNo
          }' and ReleaseDate eq ${date}`,
          // select: [
          //   "WorkOrderCode",
          //   "ProductCode",
          //   "ProductionReleaseCode",
          //   "ProductionUMQty",
          //   "StockUMQty",
          //   "ProductionUM",
          //   "StockUM",
          //   "ReleaseDate",
          //   "PalletNo",
          //   "BatchNo",
          // ],
        }
      );
    },
    getColumns() {
      return [
        {
          caption: "Release #",
          dataField: "ProductionReleaseCode",
          alignment: "left",
          cellTemplate: "release-template",
          width: 120,
        },
        {
          caption: "Card No",
          dataField: "CardNo",
          width: ColumnWidth.CardNo.width,
          maxWidth: ColumnWidth.CardNo.minWidth,
          visible: this.WorkOrderInstance === "Almondco",
        },
        {
          caption: "Pallet Number",
          dataField: "PalletNo",
          minWidth: ColumnWidth.BatchNo.minWidth,
          width: ColumnWidth.BatchNo.width,
        },
        {
          screenField: "Batch",
          caption: "Batch Code",
          dataField: "BatchNo",
          minWidth: ColumnWidth.BatchNo.minWidth,
        },
        {
          caption: "Production UM Qty",
          dataField: "ProductionUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
        },
        {
          screenField: "SalesUM",
          caption: "Production UM",
          dataField: "ProductionUM",
          minWidth: ColumnWidth.ProductionUnitOfMeasure.minWidth,
          width: ColumnWidth.ProductionUnitOfMeasure.width,
          allowSorting: true,
        },
        {
          caption: "Stock UM Qty",
          dataField: "StockUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
        },
        {
          screenField: "StockUM",
          dataField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Reversal",
              icon: "repeat",
              visible: (e) => {
                const data = e.row.data;

                if (data && data.WorkOrderFriendlyStatus === "Completed") {
                  return false;
                }

                if (data && data.Reversed === "Y") {
                  return false;
                } else {
                  return true;
                }
              },
              onClick: async (e) => {
                let confirmReverse = await this.$confirm(
                  "Are you sure you want to reverse this production release?",
                  "Reversal Confirmation"
                );

                if (confirmReverse) this.reverseProductionRelease(e);
              },
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 40,
          minWidth: 40,
          visible: this.getUserAccess,
        },
      ];
    },
    getUserAccess() {
      return FeatureStorage.checkPermission(
        "WorkOrderProductionRelease",
        "create"
      );
    },
    getFormModel() {
      return this.popupConfig.dataModel;
    },
    getHeaderFormItems() {
      return [
        {
          label: {
            text: "Release Date",
          },
          dataField: "ReleaseDate",
          editorType: "dxDateBox",
          editorOptions: {
            displayFormat: "dd MMM yyyy",
            width: 150,
          },
        },
      ];
    },
    getTitle() {
      return {
        primary: this.popupConfig.dataModel.ProductCode,
        secondary: this.popupConfig.dataModel.ProductDescription,
      };
    },
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "",
            icon: "close",
            stylingMode: "text",
            type: "default",
            onClick: this.onPopupHide,
          },
        },
      ];
    },

    footerItems() {
      return [
        {
          label: "Card Count",
          dataField: "CardNo",
          type: "count",
          location: "right",
          format: "Decimal-16-0",
          visible: this.WorkOrderInstance === "Almondco",
          value: this.popupConfig.dataModel.CardCount,
        },
        {
          label: "Pallet Count",
          dataField: "PalletNo",
          type: "count",
          location: "right",
          format: "Decimal-16-0",
          value: this.popupConfig.dataModel.PalletCount,
        },
        {
          label: "Batch Count",
          dataField: "BatchNo",
          type: "count",
          location: "right",
          format: "Decimal-16-0",
          value: this.popupConfig.dataModel.BatchCount,
        },
        {
          label: `Total (${this.popupConfig.dataModel.StockUM})`,
          dataField: "StockUMQty",
          type: "sum",
          location: "right",
          format: "Decimal-16-4",
          value: this.popupConfig.dataModel.StockUMQty,
        },
      ];
    },
    footerRightItems() {
      var rightItems = this.footerItems.filter(
        (x) => x.location == "right" && x.visible !== false
      );
      return rightItems;

      // const dataGrid = this.$refs["release-info-list-grid"].instance;
      // const items = dataGrid.getDataSource().items();

      // return rightItems
      //   .map((c) => {
      //     if (c.type === "sum") {
      //       if (c.dataField === "StockUMQty") {
      //         c.label = `Total (${items[0].StockUM})`;
      //       }
      //       c.value = items.reduce((acc, item) => {
      //         return acc + (item[c.dataField] || 0);
      //       }, 0);
      //     } else if (c.type === "count") {
      //       c.value = new Set(
      //         items
      //           .map((item) => item[c.dataField])
      //           .filter(
      //             (val) =>
      //               val !== undefined && val !== null && val !== 0 && val !== ""
      //           )
      //       ).size;
      //     }

      //     return c;
      //   })
      //   .filter((x) => x != null);
    },
  },
};
</script>

<style lang="scss">
.gc-popup-work-order-release-info {
  .data-grid {
    padding-top: 10px;
  }
}
</style>
